import {
    FEATURE_FLAG,
    parseCommaSeparatedString,
    type Environment,
} from '@quipex/core/config';
import { SUPPORT_EMAIL_CONFIG } from './support-email';

export const environment: Environment = {
    appVersion: import.meta.env.NG_APP_VERSION,
    env: import.meta.env.NG_APP_ENV,
    apiBase: import.meta.env.NG_APP_API_BASE_URL,
    apiFunctionBase: import.meta.env.NG_APP_API_FUNCTION_BASE_URL,
    apiAIBase: import.meta.env.NG_APP_API_AI_BASE_URL,
    scopes: {
        quipexApi: parseCommaSeparatedString(
            import.meta.env.NG_APP_SCOPES_QUIPEX
        ),
    },
    auth0ClientId: import.meta.env.NG_APP_AUTH0_CLIENT_ID,
    auth0Domain: import.meta.env.NG_APP_AUTH0_DOMAIN,
    auth0Audience: import.meta.env.NG_APP_AUTH0_AUDIENCE,
    graphClientId: import.meta.env.NG_APP_GRAPH_CLIENT_ID,
    dropboxClientId: import.meta.env.NG_APP_DROPBOX_CLIENT_ID,
    googleClientId: import.meta.env.NG_APP_GOOGLE_CLIENT_ID,
    sessionConfig: {
        inactiveTimeoutSeconds: 1800,
        idleTimeoutSeconds: 1,
    },
    supportEmail: SUPPORT_EMAIL_CONFIG,
    imagePreviewFileTypes: [
        'jpeg',
        'gif',
        'png',
        'apng',
        'svg',
        'bmp',
        'ico',
        'avif',
        'jpg',
    ],
    documentUploadTypes: [
        'bmp',
        'jpeg',
        'jpg',
        'pdf',
        'png',
        'tiff',
        'tif',
        'doc',
        'docx',
        'xls',
        'xlsx',
        'csv',
        'html',
        'htm',
        'mpp',
        'vsdx',
        'dwg',
        'bimx',
    ],
    maxFileSizeInMb: 500,
    concurrentFilesUpload: 250,
    instrumentationKey: import.meta.env.NG_APP_INSTRUMENTATION_KEY,
    datadogRum: {
        applicationId: import.meta.env.NG_APP_DATADOG_RUM_APPLICATION_ID,
        clientToken: import.meta.env.NG_APP_DATADOG_RUM_CLIENT_TOKEN,
        defaultPrivacyLevel: import.meta.env
            .NG_APP_DATADOG_RUM_DEFAULT_PRIVACY_LEVEL,
        sessionReplaySampleRate: import.meta.env
            .NG_APP_DATADOG_RUM_SESSION_REPLAY_SAMPLE_RATE,
        sessionSampleRate: import.meta.env
            .NG_APP_DATADOG_RUM_SESSION_SAMPLE_RATE,
    },
    autoTagMaxSizeMB: 25,
    featureFlags: {
        [FEATURE_FLAG.DocumentPackSuggestions]: true,
        [FEATURE_FLAG.BuildingAccessRequests]: false,
        [FEATURE_FLAG.BuildingIdentificationNumbers]: false,
        [FEATURE_FLAG.QuippyPackActions]: true,
        [FEATURE_FLAG.AppTopBar]: false,
        [FEATURE_FLAG.BuildingIntelligence]: false,
        [FEATURE_FLAG.BuildingIntelligenceDocument]: false,
        [FEATURE_FLAG.BuildingHostContext]: false,
        [FEATURE_FLAG.BuildingAddressContext]: true,
        [FEATURE_FLAG.BuildingDocumentReenrichment]: false,
        [FEATURE_FLAG.BuildingSustainabilityDatapoints]: true,
        [FEATURE_FLAG.GoogleDriveImport]: false,
        [FEATURE_FLAG.ProcoreImport]: false,
        [FEATURE_FLAG._Placeholder]: true,
    },
} as const;
